jQuery(document).on('ready', function() {
  var $body = jQuery('body');
  var $document = jQuery(document);

  $document.on('click', '.side-menu > ul > li:not(.linked-in)', function () {
    var $this = jQuery(this);
    var $menu = $this.closest('.side-menu');
    var target = $this.data('target');
    var $backdrop = $menu.find('.backdrop');

    if ($this.hasClass('active')) {
      $menu.removeClass('open');
      $this.removeClass('active');
      $body.removeClass('disallow-scroll');
      window.setTimeout(function (){
        $menu.find('.contents > div').hide();
      }, 1000);
      $backdrop.fadeOut(750);
      return;
    }

    $menu.find('.contents > div').hide();
    $backdrop.fadeIn(750);
    $menu.find('.contents > div[data-target="' + target + '"]').show();
    $this.parent().children().removeClass('active');
    $this.addClass('active');
    $menu.addClass('open');
    $body.addClass('disallow-scroll');
  });

  $document.on('click', '.side-menu .backdrop', function () {
    var $this = jQuery(this);
    var $menu = $this.closest('.side-menu');

    $this.fadeOut(750);
    $menu.removeClass('open');
    $menu.find('> ul > li').removeClass('active');
    $body.removeClass('disallow-scroll');
    window.setTimeout(function (){
      $menu.find('.contents > div').hide();
    }, 1000);
  });

  if (window.location.hash) {
    var hash = window.location.hash.replace(/#/,'');
    if ($('li[data-target="'+hash+'"]').length) {
      $('li[data-target="'+hash+'"]').trigger('click');
    }
  }
  $document.on('click', 'a', function(){
    if (this.href) {
      var hash = this.href.split('#');
      if (hash[1]) {
        hash = hash[1];
        if ($('li[data-target="'+hash+'"]').length) {
          $('li[data-target="'+hash+'"]').trigger('click');
        }
      }
    }
  });
});
